export const HDivider = () => (
  <div className="@HDivider h-px w-full bg-neutral/15" />
);
export const VDivider = () => (
  <div className="@VDivider h-full w-px bg-neutral/15" />
);
